"use client";

import { useActiveFeatureFlags } from "posthog-js/react";
import { useEffect } from "react";

import { sessionStorageActiveFeatureFlags, sessionStorageFeatureFlags } from "@/lib/utils/storage-apis";

import { useAdditionalEmbeddedWalletAccountsEnabled } from "./use-additional-embedded-wallet-accounts-enabled";
import { useApplicationOnboardingEnabled } from "./use-application-onboarding-enabled";
import { useEmbeddedWalletsEnabled } from "./use-embedded-wallets-enabled";
import { useHasRewardsInterest } from "./use-has-rewards-interest";
import { useLogSwapAdminActionsWithSupabase } from "./use-log-swap-admin-actions-with-supabase";
import { useMultiSignerEnabled } from "./use-multi-signer-enabled";
import { useSepaAccountsEnabled } from "./use-sepa-accounts-enabled";
import { useUserCanAccessWhitelabel } from "./use-user-can-access-whitelabel";

export function useRecordAllFlags() {
  const user_can_access_whitelabel = useUserCanAccessWhitelabel();
  const log_swap_admin_actions_with_supabase = useLogSwapAdminActionsWithSupabase();
  const has_rewards_interest = useHasRewardsInterest();
  const enable_turnkey = useEmbeddedWalletsEnabled();
  const enable_additional_embedded_wallet_accounts = useAdditionalEmbeddedWalletAccountsEnabled();
  const enable_application_onboarding = useApplicationOnboardingEnabled();
  const enable_embedded_wallet_multi_signer = useMultiSignerEnabled();
  const enable_sepa_accounts = useSepaAccountsEnabled();

  useEffect(() => {
    sessionStorageFeatureFlags.set({
      user_can_access_whitelabel: booleanOrUnknown(user_can_access_whitelabel),
      log_swap_admin_actions_with_supabase: booleanOrUnknown(log_swap_admin_actions_with_supabase),
      has_rewards_interest: booleanOrUnknown(has_rewards_interest),
      enable_turnkey: booleanOrUnknown(enable_turnkey),
      enable_additional_embedded_wallet_accounts: booleanOrUnknown(enable_additional_embedded_wallet_accounts),
      enable_application_onboarding: booleanOrUnknown(enable_application_onboarding),
      enable_embedded_wallet_multi_signer: booleanOrUnknown(enable_embedded_wallet_multi_signer),
      enable_sepa_accounts: booleanOrUnknown(enable_sepa_accounts),
    });
  }, [
    user_can_access_whitelabel,
    log_swap_admin_actions_with_supabase,
    has_rewards_interest,
    enable_turnkey,
    enable_additional_embedded_wallet_accounts,
    enable_application_onboarding,
    enable_embedded_wallet_multi_signer,
    enable_sepa_accounts,
  ]);

  const active_feature_flags = useActiveFeatureFlags();

  useEffect(() => {
    sessionStorageActiveFeatureFlags.set(active_feature_flags.sort());
  }, [active_feature_flags]);
}

function booleanOrUnknown(val: unknown): boolean | "unknown" {
  return typeof val === "boolean" ? val : "unknown";
}
